import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsDeleteUserBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Delete user</div>
          <div className="text">Deletes a user. Also deletes all of their comments and votes.</div>
          <div className="text">
            If their posts have other comments/votes, then they'll be removed as an author. If there
            are no other comments/votes, the post will be removed.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: 'The unique identifier of the user.',
                heading: 'id',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns "success" if the user was successfully deleted.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/users/delete</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/users/delete"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d userID=553c3ef8b8cdcd1501ba2200"`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">success</Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
